<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-database-check"
          inline
          class="ml-0 px-5 py-4"
          title="Validações Customizadas"
        >
          <v-btn
            v-if="accessReleased('VALIDACOES_BDGDS_MODELOS_ADICIONAR')"
            id="btn-novo-validacao-customizada"
            color="success"
            dark
            elevation="1"
            class="mt-5"
            style="float: left"
            relative
            text
            medium
            @click="$router.push('edit')"
          >
            <v-icon left size="30px">mdi-plus-circle</v-icon>
            Nova Validação
          </v-btn>

          <v-text-field
            id="validacoes-bdgds-modelos-historico-search"
            v-model="search"
            append-icon="mdi-magnify"
            class="break-search ml-auto mt-4"
            label="Procurar"
            hide-details
            single-line
            style="max-width: 250px"
          />

          <v-divider class="mt-10" />

          <v-data-table
            :headers="headers"
            :items="items"
            :search.sync="search"
            :mobile-breakpoint="800"
            :loading="loading"
            :hide-default-header="loading"
            :hide-default-footer="loading"
            no-data-text="Nenhuma validação customizada cadastrada"
          >
            <template v-slot:[`item.entidades`]="{ item }">
              {{ item.entidades.join(', ') }}
            </template>
            <template v-slot:[`item.ativo`]="{ item }">
              <v-icon v-if="item.ativo" color="success">mdi-check-circle</v-icon>
              <v-icon v-else color="grey">mdi-close-circle</v-icon>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                v-if="accessReleased('VALIDACOES_BDGDS_MODELOS_EDITAR')"
                id="btn-editar-validacao-customizada"
                color="gray"
                min-width="0"
                class="ml-n1 px-1"
                fab
                icon
                x-small
                @click="$router.push(`edit/${item.id}`)"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <template v-slot:[`footer.page-text`]>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-bind="attrs" v-on="on" @click="getValidacoesBdgdsModelos()">mdi-refresh</v-icon>
                </template>
                <span>Clique aqui para recarregar as validações customizadas</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ValidacoesBdgdsModelosService from '@/services/ValidacoesBdgdsModelosService';
  import refreshDataMixins from '@/mixins/refreshDataMixins';
  import profilePermissionsMixin from '@/mixins/profilePermissionsMixin';

  export default {
    name: 'ValidacaoBdgdModeloHistorico',

    mixins: [refreshDataMixins, profilePermissionsMixin],

    data: () => ({
      items: [],
      loading: false,
      search: '',
      headers: [
        { text: 'Nome', value: 'nome' },
        { text: 'Entidades', value: 'entidades' },
        { text: 'Campo', value: 'campo' },
        { text: 'Tipo', value: 'tipo_ocorrencia' },
        { text: 'Ativo', value: 'ativo' },
        { sortable: false, text: 'Ações', value: 'actions', class: 'pl-4' }
      ]
    }),

    mounted() {
      this.refreshData(this.getValidacoesBdgdsModelos);
    },

    methods: {
      getValidacoesBdgdsModelos() {
        this.items = [];
        this.loading = true;

        ValidacoesBdgdsModelosService.listar()
          .then((response) => {
            this.items = response.data.data;
          })
          .catch(() => {
            this.$toast.error('Erro ao recuperar as validações customizadas.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>

<style scoped></style>
